import React, { useState, Fragment, useEffect } from "react";
import { Translate } from "../../../utils/lang/translate";
import { FormatDate } from "../../../utils/lang/translate";
import { Link } from "react-router-dom";
import { FeatureLoked } from "../_Common/FeatureLoked";

import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import TableLoader from "../_Common/TableLoader";
import {
  DeletSvg,
  DoneSvg,
  FlechDwnSvg,
  FilterSvg,
  RefreshSvg,
  CloseSvg,
  ViewSvg,
  PrintSvg,
  OutSvg,
  CheckSvg,
} from "../_Common/IconSvg";
import SmallText from "../_Common/SmallText";
import InlinedElement from "../_Common/InlinedElement";
import ContainerPage from "../_Common/ContainerPage";
import GroupeBtnSp from "../_Common/GroupeBtnSp";
import DatePicker from "../../_Common/DatePicker";
import Table from "../_Common/Table";
import GroupeBtn from "../_Common/GroupeBtn";
import PaginationBar from "../_Common/PaginationBar";
import { RECEIVED_PRODUCT_HEADER } from "../../constants";
import { productActions, commonActions } from "../../../actions";
import { useQueryParam } from "use-query-params";
import PropTypes from "prop-types";

import { addUrlProps, UrlQueryParamTypes, Serialize } from "react-url-query";

import DropDown from "./InputSearch";
import { NoVoucher } from "../_Common/NoVoucher";
import { initGAPg, Event } from "../_Common";

const urlPropsQueryConfig = {
  page: { type: UrlQueryParamTypes.number },

  began: { type: UrlQueryParamTypes.string },
  end: { type: UrlQueryParamTypes.string },
};
const TakenProduct = ({
  dataExit,

  GettingBonExit,
  GetAllexitsProducts,
  props,
  Waredata,
  GetWarehouse,
  onChangePage,
  page = 1,
  onChangeBegan,
  onChangeEnd,
  onChangeDate,
  end,
  began,
}) => {
  const [listWarehouse, setListWarehouse] = useState();
  const [reference, setReference] = useQueryParam("reference");
  const [inputReference, setInputReference] = useState(reference);

  const [warehouse, setWarehouse] = useQueryParam("warehouse");
  const [titlepage, setTitlePage] = useState(
    <div>
      <Link className="StOpcVal" to="/stock/takenProduct">
        {Translate("titles", "receiveProduct")}
      </Link>
      <div className="Inlflx StWdDst">{Translate("orders", "flech")}</div>
      <span>{Translate("product", "takenProduct")}</span>
    </div>
  );

  const changeInputReference = (e) => {
    const { value } = e.target;

    setInputReference(value);
  };

  const changeSelectWarehouse = (e) => {
    const { value } = e.target;

    setWarehouse(value);
  };

  const handleReferenceInput = () => {
    Event("VOUCHER_TAKEN", "FILTER_BY_REFERENCE", "CLICK_EVENT");
    if (inputReference === reference) {
      setInputReference("");
      setReference("");
    } else {
      setReference(inputReference);
    }
  };

  const ShowFilter = () => {
    Event("VOUCHER_TAKEN", "CLICK_FILTER", "CLICK_EVENT");
    let clsList = document.getElementById("Filter_container");
    if (clsList.classList.value.indexOf("hidElem2") !== -1) {
      clsList.classList.remove("hidElem2");
      document.addEventListener("mousedown", handleClickOutsideFilter);
    } else {
      clsList.classList.add("hidElem2");
      document.removeEventListener("mousedown", handleClickOutsideFilter);
    }
  };
  const FilterRef = React.createRef();

  const handleClickOutsideFilter = (event) => {
    if (
      FilterRef &&
      FilterRef.current &&
      !FilterRef.current.contains(event.target)
    ) {
      ShowFilter();
    }
  };

  useEffect(() => {
    initGAPg();
  });

  useEffect(() => {
    GetAllexitsProducts(`delivery/vouchers/exit/?page=${page}`);
  }, [page]);

  useEffect(() => {
    if (reference && reference.length > 0)
      GetAllexitsProducts(`delivery/vouchers/exit/?search=${reference}`);
  }, [reference]);

  useEffect(() => {
    if (warehouse && warehouse.length > 0)
      GetAllexitsProducts(`delivery/vouchers/exit/?warehouse=${warehouse}`);
  }, [warehouse]);

  useEffect(() => {
    if (began && end)
      GetAllexitsProducts(
        `delivery/vouchers/exit/??start_date=${began}&end_date=${end}`
      );
  }, [began, end]);

  useEffect(() => {
    GetWarehouse();
  }, []);

  useEffect(() => {
    if (Waredata?.list?.results) {
      setListWarehouse(Waredata?.list?.results);
    }
  }, [Waredata?.list?.results]);

  function refreshPage() {
    Event("VOUCHER_TAKEN", "USE_REFRESH_VOUCHER_RECEIVE_BUTTON", "CLICK_EVENT");
    window.location.href = "/stock/takenProduct";
  }

  function resetFilter() {
    Event("VOUCHER_TAKEN", "RESET_ALL_FILTERS", "CLICK_EVENT");
    window.location.href = "/stock/receiveProduct";
  }

  let bodytab = [];

  bodytab = dataExit?.results?.map((elem) => {
    let actionBtns = [];
    const { id, reference, warehouse, created_at } = elem;

    actionBtns.push({
      type: "BDgInpc",
      action: () => (
        Event("VOUCHER_TAKEN", "VIEW_DETAILS_VOUCHER_TAKEN", "CLICK_EVENT"),
        (window.location.href = `/stock/detailTaken/${id}`)
      ),
      svgbtn: ViewSvg,
    });
    // actionBtns.push({ type: "BDgInpc", svgbtn: PrintSvg });
    return [
      "N° BS/" + reference,
      <SmallText lengthText={70}>{warehouse}</SmallText>,
      <SmallText lengthText={70}>{FormatDate(created_at)}</SmallText>,

      <GroupeBtn data_btn={actionBtns} />,
    ];
  });
  if (dataExit?.count == 0) {
    return <NoVoucher />;
  } else {
    return (
      <ContainerPage
        page_title={titlepage}
        data_top={
          <div>
            <div className="StAutMr d-sm">
              <div
                className="Inlflx AlgnItm StDrc StFlxStr FlWd"
                style={{ height: "48px" }}
              >
                <GroupeBtnSp
                  style={{ margin: "0", zoom: "1.2" }}
                  data_btn={[
                    {
                      type: "BDgInpc",
                      action: refreshPage,
                      svgbtn: RefreshSvg,
                      tooltip: Translate("tooltips", "refresh"),
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        }
      >
        <div
          className="InFlx flxDrc StmpB3 StPs zindX2 BdgGc"
          style={{ height: "48px", padding: "7px 0", top: "-20px" }}
        >
          <div role="filter-data" className="FlHg InFlx StwdMaxC flxDrc">
            <div className="FlHg ClSidTh StBrdRdS StMrtg2">
              <div onClick={ShowFilter} className="CrsPoi FlHg">
                <InlinedElement
                  secnd={<div className="IcnSiz">{FilterSvg}</div>}
                />
              </div>
              <div
                id="Filter_container"
                className="StAbs Zindxsm StLanNlin StBxSh1 StwdMaxC stTranEs StTpval3 HdOvrfl ClSidTh StPdsml StBgbrds hidElem2"
                style={{ width: "350px" }}
              >
                <div id="Sub_Container_filter">
                  <div style={{ marginTop: "8px" }}>
                    <div onClick={ShowFilter} className="RlPs">
                      <InlinedElement
                        secnd={<strong>{Translate("orders", "filter")}</strong>}
                        leftElm={
                          <div className="InFlx CrsPoi IcnSizSm">
                            {CloseSvg}
                          </div>
                        }
                        style={{ width: "100%", padding: "0px" }}
                      />
                    </div>
                    <span
                      className="CrsPoi StBle DsBlc StdirLn"
                      onClick={resetFilter}
                    >
                      {Translate("orders", "resetfilter")}
                    </span>
                  </div>
                  <div className="BdgClN StBrdRdS StPdsml SmMarS1">
                    <div className="StHeivl RlPs CrsPoi">
                      <DropDown
                        valuee={warehouse}
                        onChange={changeSelectWarehouse}
                        options={listWarehouse}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="FlHg StBrdRdS ClSidTh">
              <InlinedElement
                style={{ padding: "0" }}
                secnd={
                  <div>
                    <input
                      type="text"
                      autoComplete="off"
                      name="filterbyid"
                      value={inputReference}
                      onChange={changeInputReference}
                      style={{ width: "300px", maxWidth: "30vw" }}
                      className="StdirLn FntfMin StPdsml BdgTrans DlBrd StSizLn Fntcl"
                      placeholder={Translate("product", "searchVoucher")}
                    />
                  </div>
                }
                leftElm={
                  <button
                    onClick={handleReferenceInput}
                    className="BdgGc DlBrd CrsPoi Inlflx StBgbrd"
                    style={{ padding: "10px", margin: "0 5px" }}
                  >
                    {inputReference === reference ? OutSvg : CheckSvg}
                  </button>
                }
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div className="d-large">
              <DatePicker
                from={began}
                to={end}
                changeFrom={onChangeBegan}
                changeTo={onChangeEnd}
                chnageDate={onChangeDate}
              />
            </div>
          </div>

          <div className="StAutMr d-large">
            <div
              className="Inlflx AlgnItm StDrc StFlxStr FlWd"
              style={{ height: "48px" }}
            >
              <GroupeBtnSp
                style={{ margin: "0", zoom: "1.2" }}
                data_btn={[
                  {
                    type: "BDgInpc",
                    action: refreshPage,
                    svgbtn: RefreshSvg,
                    tooltip: Translate("tooltips", "refresh"),
                  },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="d-sm" style={{ marginBottom: "20px" }}>
          <DatePicker
            from={began}
            to={end}
            changeFrom={onChangeBegan}
            changeTo={onChangeEnd}
            chnageDate={onChangeDate}
          />
        </div>
        {GettingBonExit == 1 ? (
          <TableLoader />
        ) : (
          <Fragment>
            <Table
              thead_elem={[...RECEIVED_PRODUCT_HEADER]}
              tbody_elem={bodytab}
            />
            <div role="pagination" className="lytWdp SmMarS1">
              <div className="InFlx flxDrc FlWd RlPs AlgnItm">
                <span className="d-large">
                  {Translate("orders", "showing") +
                    " " +
                    (page * 20 - 19) +
                    " - " +
                    (page * 20 < dataExit?.count
                      ? page * 20
                      : dataExit?.count) +
                    " " +
                    Translate("orders", "of") +
                    " " +
                    dataExit?.count}
                </span>
                <PaginationBar
                  className="StAutMr"
                  NbPage={Math.trunc(dataExit?.count / 20) + 1}
                  currentPage={parseInt(page)}
                  ChangePage={onChangePage}
                  blockNext={dataExit?.next}
                  blockPrev={dataExit?.previous}
                />
              </div>
            </div>
          </Fragment>
        )}
      </ContainerPage>
    );
  }
};

function mapState(state) {
  const { dataExit, GettingBonExit } = state.product;
  const { Waredata } = state.common;

  return { dataExit, GettingBonExit, Waredata };
}

const actionCreators = {
  GetAllexitsProducts: productActions.GetAllexitsProducts,
  GetWarehouse: commonActions.GetWarehouse,
};

const connectedProductsAll = connect(mapState, actionCreators)(TakenProduct);
const QueryProps = addUrlProps({ urlPropsQueryConfig })(connectedProductsAll);
export { QueryProps as TakenProduct };

TakenProduct.defaultProps = {
  page: 1,
};

TakenProduct.propTypes = {
  page: PropTypes.number,
  began: PropTypes.string,
  end: PropTypes.string,
  onChangePage: PropTypes.func,
  onChangeBegan: PropTypes.func,
  onChangeEnd: PropTypes.func,
};
